import React from 'react';
import PropTypes from 'prop-types';

import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import ContrastIcon from '@mui/icons-material/Contrast';

const HighContrast = ({ isFilterActive, toggleOption }) => {
	const handleContrast = () => {
		if (!isFilterActive) {
			document.querySelectorAll('.filter').forEach((element) => {
				element.style.filter = 'contrast(200%)';
			});

			document.querySelectorAll('section, .filterbg').forEach((element) => {
				element.style.background = '';
			});
		}
		toggleOption();
	};
	return (
		<ListItem
			className='accessiblility-links'
			tabIndex={1}
			sx={{
				padding: '2px 18px',
				cursor: 'pointer',
				background: isFilterActive
					? (theme) => theme.palette.accessibilityBtn.main
					: (theme) => theme.palette.common.white,
				color: isFilterActive ? (theme) => theme.palette.common.white : 'inherit'
			}}
			onClick={handleContrast}
			onKeyDown={(event) => {
				if (event.key === 'Enter') {
					handleContrast();
				}
			}}
		>
			<ContrastIcon sx={{ fontSize: '14px', verticalAlign: 'middle', marginRight: '5px' }} />
			<ListItemText primary='High Contrast' primaryTypographyProps={{ sx: { fontSize: '14px' } }} />
		</ListItem>
	);
};

HighContrast.propTypes = {
	isFilterActive: PropTypes.bool,
	toggleOption: PropTypes.func
};

export default HighContrast;
